﻿$(document).ready(function () {
  // ---------------------- add to cart drawer -------------------------
  // AJAX cart redirect to checkout
  $(document).on("click", ".ajax-cart-button.shopify", function () {
    var variantID = $(this).attr("data-product-variant-id");
    $(this).closest(".plus-icon").find(".loading-button").addClass("active");
    $(this).addClass("active");
    addToCartJS(1, variantID, $(this));
  });

  function addToCartJS(qty, variantID, btn) {
    var xhr = new XMLHttpRequest();
    var url = "/cart/add.js";
    xhr.open("POST", url, true);
    xhr.setRequestHeader("Content-Type", "application/json");
    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4 && xhr.status === 200) {
        var parsedState = JSON.parse(xhr.responseText);
        $(".loading-button").removeClass("active");
        $(".ajax-cart-button").removeClass("active");
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
      }
    };
    var data = JSON.stringify({ quantity: qty, id: variantID });
    xhr.send(data);
  }


$(document).on("click", ".ajax-cart-button.boost", function () {
  var $btn = $(this);
  var handle = $btn.attr("data-products-handle");

  // Show loading states
  $btn.closest(".plus-icon").find(".loading-button").addClass("active");
  $btn.addClass("active");

  if (!handle) {
    console.error("Product handle is missing.");
    return;
  }

  // Fetch product data using handle
  fetch(`/products/${handle}.js`)
    .then(res => res.json())
    .then(product => {
      var firstVariantId = product.variants[0]?.id;
      if (!firstVariantId) {
        console.error("No variant found for product:", handle);
        return;
      }

      addToCartJSBoost(1, firstVariantId, $btn);
    })
    .catch(err => {
      console.error("Failed to fetch product data:", err);
    });
});

function addToCartJSBoost(qty, variantID, btn) {
  var xhr = new XMLHttpRequest();
  var url = "/cart/add.js";
  xhr.open("POST", url, true);
  xhr.setRequestHeader("Content-Type", "application/json");
  xhr.onreadystatechange = function () {
    if (xhr.readyState === 4 && xhr.status === 200) {
      var parsedState = JSON.parse(xhr.responseText);
      $(".loading-button").removeClass("active");
      $(".ajax-cart-button").removeClass("active");
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
    }
  };
  var data = JSON.stringify({ quantity: qty, id: variantID });
  xhr.send(data);
}

  // =================== FAQs section start =================== //
  $(".faq-v2 .has--accordion")
    .first()
    .find(".collapsible-trigger")
    .trigger("click");
  $(document).on("click", ".faq-v2 .collapsible-trigger", function () {
    $(".faq-v2 .collapsible-trigger").removeClass("is-open");
    $(".faq-v2 .collapsible-content").removeClass("is-open").css("height", "0");

    $(this).addClass("is-open");
    var content = $(this).siblings(".collapsible-content");
    var autoHeight = content.get(0).scrollHeight + "px";
    content.addClass("is-open").css("height", autoHeight);
    content.css("height", "auto");
  });

  // =================== FAQs section end =================== //

  // =================== collection list section start =================== //
  function adjustFilterPosition() {
    var collectionFilter = $(".collection-filter");
    var collectionListSection = $(".collection-list-section");

    // Check the length of collectionListSection and conditionally append it
    if ($(window).width() >= 768 && collectionListSection.length) {
      // Move collectionListSection after collectionFilter if not already moved
      if (!collectionFilter.next().is(collectionListSection)) {
        collectionFilter.after(collectionListSection);
      }
    } else if ($(window).width() < 768 && collectionListSection.length) {
      // Revert position for smaller screens (if needed)
      $(".collection-content").before(collectionListSection);
    }
  }

  // Call the function initially and on window resize
  adjustFilterPosition();
  $(window).resize(function () {
    adjustFilterPosition();
  });
  // =================== collection list section end =================== //

  // =================== product page start =================== //
  // Function to format the date with custom weekday and day suffix
  function formatCustomDate(date) {
    const options = { weekday: "long", day: "numeric", month: "long" };
    const parts = new Intl.DateTimeFormat("en-US", options).formatToParts(date);

    const getDaySuffix = (dayNumber) => {
      if (dayNumber % 10 === 1 && dayNumber % 100 !== 11) return "st";
      if (dayNumber % 10 === 2 && dayNumber % 100 !== 12) return "nd";
      if (dayNumber % 10 === 3 && dayNumber % 100 !== 13) return "rd";
      return "th";
    };

    let weekday = "",
      day = "",
      month = "";

    parts.forEach((part) => {
      if (part.type === "weekday") weekday = part.value;
      if (part.type === "day")
        day = `${part.value}${getDaySuffix(+part.value)}`;
      if (part.type === "month") month = part.value;
    });

    return `${weekday}, ${day} ${month}`;
  }

  // Example usage
  $(document).ready(function () {
    const currentDate = new Date();
    const givenDate =
      parseInt($(".countdown-timer .set-date").attr("data-date"), 10) || 0;
    const futureDate = new Date(
      currentDate.setDate(currentDate.getDate() + givenDate)
    );
    $(".countdown-timer .set-date").text(formatCustomDate(futureDate));
  });

  // Set the target date to the end of today
  var targetDate = new Date();
  targetDate.setHours(23, 59, 59, 999); // Set to the last millisecond of today

  // Start the countdown
  var countdownInterval = setInterval(function () {
    var now = new Date().getTime();
    var timeRemaining = targetDate - now;

    // Check if the countdown has ended
    if (timeRemaining <= 0) {
      clearInterval(countdownInterval);
      $("#days").text("0");
      $("#hours").text("0");
      $("#minutes").text("0");
      $("#seconds").text("0");
      return;
    }

    // Calculate remaining hours, minutes, and seconds
    var hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Display the results
    $("#days").text("0"); // For the rest of today, days will be zero
    $("#hours").text(hours);
    $("#minutes").text(minutes);
    $("#seconds").text(seconds);
  }, 1000);

  // First tab open JS
  $(".product-block--tab")
    .first()
    .find(".collapsible-trigger")
    .trigger("click");

  // review position changes JS
  var productTtile = $(".product-page-right--content .review_content");
  if (productTtile.length > 0) {
    $(".product-page-right--content .product-block--header").before(
      productTtile
    );
  }
  // =================== product page end =================== //

  $(".service-icon-text-slider").slick({
    dots: false,
    arrow: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke_1.png?v=1732266566"></button>`,
          nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke.png?v=1732266566"></button>`,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke_1.png?v=1732266566"></button>`,
          nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke.png?v=1732266566"></button>`,
          infinite: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          prevArrow: `<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke_1.png?v=1732266566"></button>`,
          nextArrow: `<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0468/8730/5378/files/Arrow_3_Stroke.png?v=1732266566"></button>`,
          infinite: true,
        },
      },
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ],
  });

  $(".logo-bar-slider").slick({
    autoplay: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    infinite: true,
    dots: false,
    arrows: false,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
});

// document.addEventListener("DOMContentLoaded", function() {
//   const sliderElement = document.querySelector(".service-icon-text-slider");

//   if (sliderElement) {
//     new Flickity(sliderElement, {
//       cellAlign: "left",        // Align cells to the left
//       contain: true,            // Keep the slider contained
//       wrapAround: true,         // Enable infinite scrolling
//       autoPlay: 3000,           // Auto-play every 3 seconds
//       prevNextButtons: false,   // Hide previous/next buttons
//       pageDots: true,           // Enable page dots
//       draggable: true           // Enable dragging
//     });
//   }
// })


  window.addEventListener('load', function () {
    setTimeout(function () {
      const btn = document.querySelector('button.md-orbe-custom-selector');
      if (btn) {
        btn.style.display = 'flex';
      }
    }, 1500);
  });


  function moveButtonForMobile() {
    const button = document.querySelector('button.md-orbe-custom-selector');
    const mobileNav = document.querySelector('ul.mobile-nav');
    const existingClone = document.querySelector('ul.mobile-nav .md-orbe-custom-selector');

    if (window.innerWidth <= 530) {
      if (button && mobileNav && !existingClone) {
        const buttonClone = button.cloneNode(true);
        const newListItem = document.createElement('li');
        newListItem.classList.add('mobile-nav__item', 'mobile-nav__item--secondary' , 'custom-selector');
        newListItem.appendChild(buttonClone);
        mobileNav.appendChild(newListItem);
        button.style.display = 'none';
      }
    } else {
      // Restore the original button if screen is wider than 530px
      if (button) {
        button.style.display = 'flex';
      }
      // Remove cloned button from mobile nav if it exists
      if (existingClone && existingClone.closest('li.mobile-nav__item')) {
        existingClone.closest('li.mobile-nav__item').remove();
      }
    }
  }

  // Run on load and resize
  window.addEventListener('load', moveButtonForMobile);
  window.addEventListener('resize', moveButtonForMobile);

// ===================== Gift Add-Ons =====================
(function () {
  'use strict';

  var cfg = window.giftAddonConfig || {};
  if (!cfg.giftBoxVariantId && !(cfg.greetingCardProducts && cfg.greetingCardProducts.length)) return;

  // ── Helpers ────────────────────────────────────────────
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // Full drawer rebuild — avoids stale CartForm DOM references after innerHTML swaps.
  function rebuildDrawer() {
    return fetch('/cart?view=drawer&t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.getElementById('CartDrawer');
        var currentDrawer = document.getElementById('CartDrawer');
        if (newDrawer && currentDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          currentDrawer.classList.remove('is-empty');
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: {} }));
        }
      });
  }

  // Fetches the Liquid-rendered gift-addons endpoint.
  // This checks product.metafields.custom.gift_options server-side,
  // which /cart.js cannot do (it does not expose metafields).
  function giftAddonFetch() {
    return fetch('/cart?view=gift-addons').then(function (r) { return r.json(); });
  }

  // ── Build HTML ──────────────────────────────────────────
  function buildGiftBoxRow(productTitle, quantity) {
    var qty = quantity || 1;
    var iconHtml = cfg.giftBoxImageUrl
      ? '<img class="gift-addon__box-img" src="' + esc(cfg.giftBoxImageUrl) + '" alt="" width="48" height="48">'
      : '<span class="gift-addon__icon">&#127873;</span>';
    return '<div class="gift-addon gift-addon--box"'
      + ' data-product-title="' + esc(productTitle) + '"'
      + ' data-gift-box-variant="' + cfg.giftBoxVariantId + '"'
      + ' data-gift-qty="' + qty + '">' +
      '<div class="gift-addon__row">' +
      iconHtml +
      '<span class="gift-addon__text">Add ' + (qty > 1 ? qty + ' gift boxes' : 'a gift box') + ' for <strong>' + esc(productTitle) + '</strong></span>' +
      '<span class="gift-addon__price">+ ' + esc(cfg.giftBoxPrice) + (qty > 1 ? ' each' : '') + '</span>' +
      '<button type="button" class="btn btn--small gift-addon__btn js-add-gift-box"'
      + ' aria-label="Add gift box for ' + esc(productTitle) + '">Add gift box</button>' +
      '</div></div>';
  }

  function buildGreetingCardSlider(qualifyingItems) {
    var max = cfg.msgMaxLength || 250;
    var cards = (cfg.greetingCardProducts || []).map(function (p) {
      return '<button type="button" class="gift-addon__card-option js-select-greeting-card"' +
        ' data-variant-id="' + esc(String(p.variantId)) + '"' +
        ' data-title="' + esc(p.title) + '">' +
        '<img class="gift-addon__card-img" src="' + esc(p.image) + '" alt="' + esc(p.title) + '">' +
        '<div class="gift-addon__card-name">' + esc(p.title) + '</div>' +
        '<div class="gift-addon__card-price">' + esc(p.price) + '</div>' +
        '</button>';
    }).join('');

    // Product association UI: auto-select when one qualifying item, dropdown when multiple
    var items = (qualifyingItems || []);
    var headerNote = '';
    var detailsForHtml = '';
    if (items.length === 1) {
      var prodTitle = items[0].title || '';
      if (prodTitle) headerNote = ' &mdash; for <strong>' + esc(prodTitle) + '</strong>';
      detailsForHtml = '<input type="hidden" class="gift-addon__for-select" value="' + esc(prodTitle) + '">';
    } else if (items.length > 1) {
      var opts = items.map(function (item) {
        return '<option value="' + esc(item.title || '') + '">' + esc(item.title || '') + '</option>';
      }).join('');
      detailsForHtml = '<label class="gift-addon__msg-label" for="GiftCardForProduct">Which product is this gift card for?</label>' +
        '<select class="select-input gift-addon__for-select" id="GiftCardForProduct">' +
        '<option value="" disabled selected>Choose a product\u2026</option>' + opts +
        '</select>';
    }

    return '<div class="gift-addon gift-addon--card-picker" data-msg-max="' + max + '">' +
      '<div class="gift-addon__picker-header">' +
      '<span class="gift-addon__icon">&#128140;</span>' +
      '<span class="gift-addon__text">Add a gift card to your order' + headerNote + '</span>' +
      '</div>' +
      '<div class="gift-addon__card-slider"><div class="gift-addon__card-track">' + cards + '</div></div>' +
      '<div class="gift-addon__details" hidden>' +
      detailsForHtml +
      '<label class="gift-addon__msg-label" for="GiftCardMessage">' +
      'Gift card message <span class="gift-addon__optional">(optional)</span></label>' +
      '<textarea class="gift-addon__textarea input-full" id="GiftCardMessage" rows="3"' +
      ' placeholder="Write your personal message here\u2026" maxlength="' + max + '"></textarea>' +
      '<p class="gift-addon__char-count"><span class="js-char-count">0</span>\u202f/\u202f' + max + ' characters</p>' +
      '<button type="button" class="btn gift-addon__btn js-add-greeting-card" disabled>Add to cart</button>' +
      '</div></div>';
  }

  function buildGreetingCardAdded(gc) {
    var max = cfg.msgMaxLength || 250;
    var msg = gc.message || '';
    var titleHtml = gc.title ? ' \u2014 <em>' + esc(gc.title) + '</em>' : '';
    var forHtml = gc.gift_card_for ? ' for <em>' + esc(gc.gift_card_for) + '</em>' : '';
    return '<div class="gift-addon gift-addon--card gift-addon--added"' +
      ' data-line-key="' + esc(gc.key) + '"' +
      ' data-greeting-card-variant="' + esc(String(gc.variant_id)) + '"' +
      ' data-gift-card-for="' + esc(gc.gift_card_for || '') + '"' +
      ' data-msg-max="' + max + '">' +
      '<div class="gift-addon__added-row">' +
      '<span class="gift-addon__icon">&#128140;</span>' +
      '<span class="gift-addon__text">Gift card added' + titleHtml + forHtml + '</span>' +
      '<button type="button" class="gift-addon__link-btn js-edit-greeting-card">Edit message</button>' +
      '<button type="button" class="gift-addon__link-btn gift-addon__link-btn--remove js-remove-greeting-card">Remove</button>' +
      '</div>' +
      '<div class="gift-addon__details" hidden>' +
      '<label class="gift-addon__msg-label" for="GiftCardMessageEdit-' + esc(gc.key) + '">' +
      'Gift card message <span class="gift-addon__optional">(optional)</span></label>' +
      '<textarea class="gift-addon__textarea input-full" id="GiftCardMessageEdit-' + esc(gc.key) + '" rows="4"' +
      ' maxlength="' + max + '">' + esc(msg) + '</textarea>' +
      '<p class="gift-addon__char-count"><span class="js-char-count">' + msg.length + '</span>\u202f/\u202f' + max + ' characters</p>' +
      '<button type="button" class="btn gift-addon__btn js-save-greeting-card">Save message</button>' +
      '</div></div>';
  }

  // ── Render into containers ──────────────────────────────
  function render(giftData) {
    var containers = document.querySelectorAll('.js-gift-addons-container');
    if (!containers.length) return;

    // Don't blow away the UI while the user has the details panel open or
    // is typing in the message textarea. Re-render will happen on the next
    // cart event after they finish.
    if (document.querySelector('.gift-addon__details:not([hidden])')) return;

    var html = '';

    // Gift Box prompts
    // qualifying_items is already filtered by metafield server-side in cart.gift-addons.liquid
    if (cfg.giftBoxVariantId && cfg.giftBoxHandle) {
      var mappedTitles = {};
      (giftData.gift_box_items || []).forEach(function (box) {
        if (box.gift_box_for) mappedTitles[box.gift_box_for] = true;
      });
      // Aggregate quantity across all line items for the same product title
      var titleQtyMap = {};
      (giftData.qualifying_items || []).forEach(function (item) {
        titleQtyMap[item.title] = (titleQtyMap[item.title] || 0) + (item.quantity || 1);
      });
      Object.keys(titleQtyMap).forEach(function (title) {
        if (!mappedTitles[title]) {
          html += buildGiftBoxRow(title, titleQtyMap[title]);
        }
      });
    }

    // Greeting Card picker
    var greetingCardProducts = cfg.greetingCardProducts || [];
    if (greetingCardProducts.length > 0 && giftData.item_count > 0) {
      var cardsInCart = giftData.greeting_cards_in_cart || [];
      if (cardsInCart.length > 0) {
        cardsInCart.forEach(function (gc) { html += buildGreetingCardAdded(gc); });
      } else {
        html += buildGreetingCardSlider(giftData.qualifying_items || []);
      }
    }

    containers.forEach(function (c) { c.innerHTML = html; });
    checkOrphans(giftData);
  }

  function fetchAndRender() {
    if (!document.querySelector('.js-gift-addons-container')) return;
    giftAddonFetch().then(render).catch(function (e) { console.warn('Gift Add-Ons render:', e); });
  }
  window.giftAddonFetchAndRender = fetchAndRender;

  // ── Orphan warnings ─────────────────────────────────────
  function checkOrphans(giftData) {
    // all_titles includes every product title in the cart (qualifying or not)
    var allTitles = giftData.all_titles || [];
    document.querySelectorAll('.gift-addon__orphan-warning').forEach(function (el) {
      var forTitle = el.getAttribute('data-gift-box-for');
      if (forTitle && allTitles.indexOf(forTitle) === -1) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', '');
      }
    });
  }

  // ── Cart remove button interception ────────────────────
  // The Avada theme's quantityChanged bails when qty === 0, and the remove
  // <a href> link is a plain page navigation — neither triggers cart:updated.
  // We intercept here so removal is handled via AJAX and the gift addon UI
  // updates immediately without a full page reload.
  document.addEventListener('click', function (e) {
    var removeLink = e.target.closest('.cart__remove a');
    if (!removeLink) return;
    var href = removeLink.getAttribute('href') || '';
    var match = href.match(/[?&]id=([^&]+)/);
    if (!match) return;
    e.preventDefault();
    var key = decodeURIComponent(match[1]);
    // Use theme.cart.changeItem so the locale-aware URL and Avada headers are applied.
    theme.cart.changeItem(key, 0)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: {cart: cart}}));
        setTimeout(fetchAndRender, 450);
      })
      .catch(function () { window.location = href; });
  });

  // ── Event delegation ────────────────────────────────────
  document.addEventListener('click', function (e) {
    var t = e.target;

    // Add gift box
    if (t.classList.contains('js-add-gift-box')) {
      var addon = t.closest('.gift-addon--box');
      var productTitle = addon.getAttribute('data-product-title');
      var variantId = parseInt(addon.getAttribute('data-gift-box-variant'));
      var quantity = parseInt(addon.getAttribute('data-gift-qty') || '1', 10);
      if (!variantId) return;
      t.disabled = true; t.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
          id: variantId, quantity: quantity,
          properties: {'Gift box for': productTitle, '_gift_box_for': productTitle}
        })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) {
          console.error('[Gift Add-Ons] Add gift box failed (' + r.status + '):', e.description || e);
          t.disabled = false; t.textContent = 'Add gift box';
        });
        rebuildDrawer().then(fetchAndRender);
      }).catch(function () { t.disabled = false; t.textContent = 'Add gift box'; });
    }

    // Select greeting card design
    if (t.closest('.js-select-greeting-card')) {
      var card = t.closest('.js-select-greeting-card');
      var picker = card.closest('.gift-addon--card-picker');
      picker.querySelectorAll('.js-select-greeting-card').forEach(function (c) { c.classList.remove('is-selected'); });
      card.classList.add('is-selected');
      var details = picker.querySelector('.gift-addon__details');
      details.removeAttribute('hidden');
      var addBtn = picker.querySelector('.js-add-greeting-card');
      if (addBtn) addBtn.disabled = false;
    }

    // Add greeting card
    if (t.classList.contains('js-add-greeting-card')) {
      var picker = t.closest('.gift-addon--card-picker');
      var selected = picker && picker.querySelector('.js-select-greeting-card.is-selected');
      var variantId = selected && parseInt(selected.getAttribute('data-variant-id'));
      if (!variantId) return;
      var msg = (picker.querySelector('.gift-addon__textarea') || {}).value || '';
      var prodEl = picker.querySelector('.gift-addon__for-select');
      var prodFor = prodEl ? (prodEl.value || '').trim() : '';
      t.disabled = true; t.textContent = 'Adding\u2026';
      var props = {};
      if (msg.trim()) props['Gift card message'] = msg.trim();
      if (prodFor) { props['_gift_card_for'] = prodFor; props['Gift card for'] = prodFor; }
      fetch('/cart/add.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: variantId, quantity: 1, properties: props})
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) {
          console.error('[Gift Add-Ons] Add greeting card failed (' + r.status + '):', e.description || e);
          t.disabled = false; t.textContent = 'Add to cart';
        });
        rebuildDrawer().then(fetchAndRender);
      }).catch(function () { t.disabled = false; t.textContent = 'Add to cart'; });
    }

    // Toggle edit panel on added card
    if (t.classList.contains('js-edit-greeting-card')) {
      var details = t.closest('.gift-addon--added').querySelector('.gift-addon__details');
      if (details.hasAttribute('hidden')) {
        details.removeAttribute('hidden');
        var ta = details.querySelector('.gift-addon__textarea');
        if (ta) ta.focus();
      } else {
        details.setAttribute('hidden', '');
      }
    }

    // Save greeting card message (remove + re-add)
    if (t.classList.contains('js-save-greeting-card')) {
      var addon = t.closest('.gift-addon--added');
      var lineKey = addon.getAttribute('data-line-key');
      var variantId = parseInt(addon.getAttribute('data-greeting-card-variant'));
      var newMsg = ((addon.querySelector('.gift-addon__textarea') || {}).value || '').trim();
      var prodFor = (addon.getAttribute('data-gift-card-for') || '').trim();
      t.disabled = true; t.textContent = 'Saving\u2026';
      var props = {};
      if (newMsg) props['Gift card message'] = newMsg;
      if (prodFor) { props['_gift_card_for'] = prodFor; props['Gift card for'] = prodFor; }
      fetch('/cart/change.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: lineKey, quantity: 0})
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({id: variantId, quantity: 1, properties: props})
        });
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) {
          console.error('[Gift Add-Ons] Save greeting card failed (' + r.status + '):', e.description || e);
          t.disabled = false; t.textContent = 'Save message';
        });
        rebuildDrawer().then(fetchAndRender);
      }).catch(function () { t.disabled = false; t.textContent = 'Save message'; });
    }

    // Remove greeting card
    if (t.classList.contains('js-remove-greeting-card')) {
      var lineKey = t.closest('.gift-addon--added').getAttribute('data-line-key');
      t.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST', headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: lineKey, quantity: 0})
      }).then(function () { rebuildDrawer().then(fetchAndRender); })
        .catch(function () { t.disabled = false; });
    }
  });

  // ── Character counters ──────────────────────────────────
  document.addEventListener('input', function (e) {
    var t = e.target;
    if (t.classList.contains('gift-addon__textarea')) {
      var container = t.closest('[data-msg-max]');
      var counter = container && container.querySelector('.js-char-count');
      if (counter) counter.textContent = t.value.length;
    }
    if (t.id === 'GreetingCardMessageInput') {
      var counter = document.getElementById('GreetingCardCharCount');
      if (counter) counter.textContent = t.value.length;
    }
  });

  // ── Gift Box product page picker ────────────────────────
  // Uses giftAddonFetch() so qualifying items are metafield-derived, not tag-based
  function initGiftBoxPicker() {
    var select   = document.getElementById('GiftBoxProductSelect');
    var hVisible = document.getElementById('GiftBoxForVisible');
    var hHidden  = document.getElementById('GiftBoxForHidden');
    var noItems  = document.getElementById('GiftBoxPickerNoItems');
    if (!select) return;

    giftAddonFetch().then(function (giftData) {
      var eligible = giftData.qualifying_items || [];

      select.innerHTML = '';

      if (eligible.length === 0) {
        select.style.display = 'none';
        if (noItems) noItems.removeAttribute('hidden');
        return;
      }

      if (noItems) noItems.setAttribute('hidden', '');
      select.style.display = '';

      if (eligible.length > 1) {
        var blank = document.createElement('option');
        blank.value = ''; blank.textContent = 'Select a product\u2026';
        select.appendChild(blank);
      }

      eligible.forEach(function (item) {
        var opt = document.createElement('option');
        opt.value = item.title; opt.textContent = item.title;
        select.appendChild(opt);
      });

      if (eligible.length === 1) {
        select.value = eligible[0].title;
        if (hVisible) hVisible.value = eligible[0].title;
        if (hHidden)  hHidden.value  = eligible[0].title;
      }

      select.addEventListener('change', function () {
        if (hVisible) hVisible.value = this.value;
        if (hHidden)  hHidden.value  = this.value;
      });
    }).catch(function (e) { console.warn('Gift Add-Ons picker:', e); });
  }

  // ── Init ────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      fetchAndRender();
      initGiftBoxPicker();
    });
  } else {
    fetchAndRender();
    initGiftBoxPicker();
  }

  // Re-render after cart changes (small delay lets the drawer update settle first)
  document.addEventListener('cart:build', function () {
    setTimeout(fetchAndRender, 400);
  });

  // Also re-render after item removal/quantity changes (theme fires cart:updated, not cart:build)
  document.addEventListener('cart:updated', function () {
    setTimeout(fetchAndRender, 400);
  });

  // Re-render whenever the cart drawer is opened — catches any state changes
  // that happened outside our interception (e.g. full-page remove navigations)
  document.addEventListener('drawerOpen.CartDrawer', function () {
    fetchAndRender();
  });

}());
// ===================== End Gift Add-Ons =====================
